'use client';

import type { ReactNode } from 'react';
import { useVehicleCompareState } from './VehicleCompareContext';

export interface StickyListWrapperProps {
    children: ReactNode;
}

export function StickyListWrapper({ children }: StickyListWrapperProps) {
    const { categories } = useVehicleCompareState();

    return categories.length > 0 ? children : null;
}
